import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CuiButtonComponent, CuiDialogContainerComponent } from '@idealink-material/ui-core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '@/core/service/auth.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-duplicate-session-dialog',
    template: `<p-dialog-container #dialogContainer [title]="'session.duplicate.title' | translate" [showClose]="false" [dividers]="false">
        <div class="col-12 text-center mt-3 mb-3">
            <p>{{ 'session.duplicate.message' | translate }}</p>
        </div>
        <div class="text-center">
            <p-button icon="logout" iconPos="left" (onClick)="closed()">{{ 'session.duplicate.logout' | translate }}</p-button>
        </div>
    </p-dialog-container> `,
    styles: `
        input:-webkit-autofill {
            background-color: transparent !important;
            color: inherit !important;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CuiButtonComponent, CuiDialogContainerComponent, ReactiveFormsModule, TranslatePipe]
})
export class SessionDuplicate {
    @ViewChild('dialogContainer') dialogContainer!: CuiDialogContainerComponent;
    auth = inject(AuthService);

    closed(): void {
        this.dialogContainer.close();
        this.auth.logout();
    }
}
